module.exports = __webpack_public_path__ + "/images/cover-cta-happy-pregnant.4561a39.png";